import { Fragment } from "react";
import { JobPostingContent } from "./jobPostings";

// Splits "Some **bold** text **here**" into alternating normal/bold spans.
function BoldText({ text }: { text: string }) {
  const parts = text.split(/\*\*(.+?)\*\*/g);
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <strong key={i} className="!text-white">
            {part}
          </strong>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        ),
      )}
    </>
  );
}

const UGG_INTRO_PARAGRAPHS = [
  "U.GG was built around taking the guesswork out of League of Legends so you can focus on playing with friends, refining your skill, and winning more. Our platforms center on providing data-driven recommendations through analyzing hundreds of millions of matches. In addition to our data offerings, we have also expanded into CMS powered recommendations, insights, and news for other games outside of League of Legends. Today, the U.GG platform and supported products service over 10 million players monthly.",
  "U.GG is a close-knit team who are passionate about video games, data analytics, and building tools that we ourselves use on a daily basis. We're looking for a {title} who has the experience and knowledge required to continue elevating our product offerings to the next level. Our company culture of honesty, ownership, and care is vital to us. While we are a remote first company, we are prioritizing candidates in North American timezones.",
];

interface JobPostingRendererProps {
  title: string;
  content: JobPostingContent;
}

export const JobPostingRenderer = ({ title, content }: JobPostingRendererProps) => (
  <div className="space-y-10">
    <section>
      <h2 className="text-xl font-semibold mb-4">We're looking for a {title} to join our team!</h2>
      {UGG_INTRO_PARAGRAPHS.map((para, i) => (
        <p key={i} className="!text-lavender-50 leading-relaxed mb-4">
          {para.replace("{title}", title)}
        </p>
      ))}
    </section>

    {content.sections.map((section, i) => (
      <section key={i}>
        <h2 className="text-xl font-semibold mb-4">{section.title}</h2>
        {section.subtitle && <p className="!text-lavender-50 text-sm mb-4">{section.subtitle}</p>}
        {section.paragraphs?.map((para, j) => (
          <p key={j} className="!text-lavender-50 leading-relaxed mb-4">
            {para}
          </p>
        ))}
        {section.bullets && (
          <ul className="list-disc list-inside pl-10 space-y-3 [&_strong]:!text-white !text-lavender-50">
            {section.bullets.map((bullet, j) => (
              <li key={j}>
                <BoldText text={bullet} />
              </li>
            ))}
          </ul>
        )}
      </section>
    ))}
  </div>
);
